// Done per Vince's demo.
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navigation from "./components/Navigation";
// import { ConnectRedux } from "./components/ConnectRedux/ConnectRedux";
import Navbar from "./components/Navbar";
import useAuth from "./hooks/useAuth";
import Login from "./components/Login/Login";

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="row">
        <div className="col-xl-12">
          <div>
            <Navigation />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
